import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import LoadingSpinner from '../partials/LoadingSpinner';
import { Button, Text, Small, H4 } from '@bigcommerce/big-design';

import { getOrderShipments } from '../../redux/actions/incompleteOrders';
import { OpenInNewIcon, AddIcon, ReceiptIcon, CheckIcon } from '@bigcommerce/big-design-icons';


const UnfulfilledOrderLine = ({ payload, order, getShipments, incompleteOrders, searchOrder, setSearchSubmitted, disabled, stores }) => {
  const submitSearch = (orderId) => {
    searchOrder(payload, orderId);
    setSearchSubmitted(true);
  }

  useEffect(() => {
    getShipments(payload, order.id);
  }, []);

  return(
    <>
      <div className="has-hover sku-line flex-container">
        <div className="flex-4">
          <H4>
            <span className="no-style">
              <a target="_blank" href={`${stores.settings.control_panel_base_url}/manage/orders/${order.id}`}>Order #{order.id}</a>
            </span>
          </H4>
          { (incompleteOrders.searchingShipments.indexOf(order.id) === -1) && (incompleteOrders.searchedShipments[order.id]) && (incompleteOrders.searchedShipments[order.id].length > 0) && incompleteOrders.searchedShipments[order.id].map((shipment) =>
              <Text color="primary40">Shipment: {shipment.items_total} items shipping to {shipment.city} {shipment.state}, {shipment.country_iso2}</Text>
            )
          }
          { (incompleteOrders.searchingShipments.indexOf(order.id) > -1) &&
            <LoadingSpinner size="xxSmall" statusText="Loading order shipments" />
          }
          { (incompleteOrders.searchingShipments.indexOf(order.id) === -1) && (!incompleteOrders.searchedShipments[order.id]) &&
            <Small>No shipments found</Small>
          }
           <Small>
            { order.customer_message &&
             <>Customer Message: {order.customer_message}<br/></>
            }
            { order.staff_notes &&
              <>Staff Notes: {order.staff_notes}</>
            }
          </Small>
        </div>

        <div className="flex-1">
          <Button
            onClick={() => submitSearch(order.id)}
            isLoading={disabled}
            disabled={disabled}
          >
            Pick Order
          </Button>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  stores: state.stores,
  incompleteOrders: state.incompleteOrders
});

const mapDispatchToProps = (dispatch) => ({
  getShipments: (payload, orderId) => dispatch(getOrderShipments(payload, orderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnfulfilledOrderLine);
